import type { EditableGoalFields } from "../types";

export const validateGoalFields = (fields: EditableGoalFields): Record<string, string> => {
	const errors: Record<string, string> = {};

	if (!fields.name || fields.name.trim().length < 4) {
		errors.name = "Name must be at least 4 characters";
	} else if (fields.name.length > 280) {
		errors.name = "Name must be 280 characters or fewer";
	}

	if (!fields.target || isNaN(Number(fields.target))) {
		errors.target = "Target must be a valid number";
	}

	if (!fields.startDate) {
		errors.startDate = "Start date is required";
	}

	if (fields.endDate && fields.startDate && fields.endDate < fields.startDate) {
		errors.endDate = "End date must be on or after start date";
	}

	if (!fields.assignee) {
		errors.assignee = "Assignee is required";
	}

	return errors;
};
